// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-product-list-element',
    // #endregion
    // #region Properties
    props: {
        catalogID: {
            type: String,
            required: false,
            default: ""
        },
        categoryID: {
            type: String,
            required: false,
            default: ""
        },
        mode: {
            type: String,
            required: false,
            default: ""
        }
    },
    data: () => ({
        category: {},
        filter: [],
        pageSize: 3,
        recordCount: 0,
        isLoading: false
    }),
    // #endregion       
    // #region Constructor
    created() {
        this.loadCategory();
    },
    // #endregion
    // #region Core
    methods: {
        async loadCategory() {
            // #region Check
            if (utils.isEmpty(this.categoryID)) {
                return;
            }
            // #endregion
            // #region Query
            //Catalog
            let tQuery = 'commerce/catalog';
            {
                if (this.catalogID) {
                    tQuery += `/${this.catalogID}`;
                }
                else {
                    return;
                }
            }
            //Category
            tQuery += '/category';
            {
                if (this.categoryID) {
                    tQuery += `/${this.categoryID}`;
                }
            }
            // #endregion
            // #region Loading
            this.isLoading = true;
            // #endregion
            // #region Run
            try {
                //Run
                let tResult = await host.api.get(tQuery);
                {
                    if (tResult.status === 204) {
                        //Result
                        this.isLoading = false;
                        return;
                    }
                    if (!tResult.data) {
                        this.isLoading = false;
                        return;
                    }
                }
                //Data
                this.category = tResult.data;
                //Internal
                this.isLoading = false;
            }
            catch (e) {
                this.isLoading = false;
            }
            // #endregion
        },
    }
    // #endregion
});
// #endregion
